module.exports = __webpack_public_path__ + "static/media/alimentation_3.a6275fc7.jpg";